// eslint-disable-next-line @typescript-eslint/no-explicit-any
const saveRecording = (recorder) => recorder && recorder.state !== 'inactive' && recorder.stop();
export default saveRecording;
